import { Modal, Text, defineModal } from '@libs/ui/ds'
import { useCommonAppTranslation } from '@libs/utils/translations'
import React from 'react'
import type { ReactNode, FC } from 'react'

type ConfirmationModalProps = {
  title: string
  leftIconTitle?: ReactNode
  message: string | ReactNode
  onConfirm: () => void
}

export const confirmationModalDef = defineModal<ConfirmationModalProps>({
  name: 'ConfirmationMessageModal'
})
const ConfirmationModal: FC = () => {
  const { t } = useCommonAppTranslation()

  const { close, isOpen, data } = confirmationModalDef.useModal()

  if (!data) {
    return null
  }

  const handleClickConfirm = () => {
    close()
    data.onConfirm()
  }

  return (
    <Modal
      opened={isOpen}
      onClose={close}
      variant='center'
      size='s'
      height='max-m'
    >
      <Modal.Header
        title={data.title}
        {...(data.leftIconTitle && { leftIcon: data.leftIconTitle })}
      />
      <Modal.Content>
        <Text size='m'>{data.message}</Text>
      </Modal.Content>
      <Modal.Footer>
        <Modal.Footer.Cancel>{t('action.cancel')}</Modal.Footer.Cancel>
        <Modal.Footer.Danger onClick={handleClickConfirm}>
          {t(`action.confirm`)}
        </Modal.Footer.Danger>
      </Modal.Footer>
    </Modal>
  )
}

export default confirmationModalDef.withModalShow(ConfirmationModal)
